<template>
  <div class="newservice col-md-12 m-0 p-0 my-2">
    <div class="row col-md-12 m-0 p-0 my-2">
      <div class="col-12 col-md-4 text-left left-panel" v-if="!showModal">
        <div class="border">
        <div class="card text-center p-2 border-0" style="background:#E9ECEF">
          <div class="col-md-12 m-0 p-0">
            <div class="col-md-12" style="margin:0 auto">
              <!-- <img
                style="border-radius:50%"
                width="100%"
                :src="customer.profilePicture"
                alt=""
              /> -->
              <b-avatar size="52px" target="_blank" :href="customer.profilePicture" v-if="customer.profilePicture" variant="info" :src="customer.profilePicture">
                <template #badge>{{customer.aqStatus}}<b-icon icon="star-fill"></b-icon></template>
              </b-avatar>
              <b-avatar size="52px" variant="dark" v-else>
                <template #badge>{{customer.aqStatus}}<b-icon icon="star-fill"></b-icon></template>
              </b-avatar>
            </div>
          </div>
          <p class="m-0 p-0 my-2" v-if="!changeName">
            <strong>{{ customer.fName }} {{ customer.lName }}</strong>
            <b-icon
              v-b-tooltip.hover
              title="Edit Name"
              class="ml-2 icon"
              style="cursor:pointer"
              variant="secondary"
              v-on:click="changeName = !changeName"
              icon="pencil"
              scale="1"
            ></b-icon>
            <b-icon
              v-b-tooltip.hover
              title="Send Direct Message"
              class="ml-2 icon"
              style="cursor:pointer"
              variant="secondary"
              v-on:click="sendDM()"
              icon="cursor"
              scale="1"
            ></b-icon>
          </p>
          <div class="my-2" v-else>
            <!-- <input type="text" v-model="fname">
            <input type="text" v-model="lname"> -->
            <div>
              <b-input-group prepend="First and last name" class="mb-2">
                <b-form-input
                  v-model="fname"
                  aria-label="First name"
                ></b-form-input>
                <b-form-input
                  v-model="lname"
                  aria-label="Last name"
                ></b-form-input>
              </b-input-group>
            </div>
            <b-button @click="updateName()" variant="light border">
              Update
            </b-button>
            <i
              v-on:click="changeName = !changeName"
              class="fa fa-times ml-2 mt-2 p-1 edit-btn"
              style=""
              aria-hidden="true"
            ></i>
          </div>
          <span class="labels m-0 p-0"
            >Since {{ customer.createdAt | moment("MMMM Do YYYY") }}</span
          >
        </div>
          <!-- {{agentActivity}} -->
          <div
            v-if="agentActivity.length > 0"
            class="col-md-12 text-left m-0 p-0 p-2"
            style="max-height:200px;overflow:scroll"
          >
            <p class="labels m-0 p-0">Activities</p>
            <div
              class="col-md-12 m-0 p-0"
              v-for="(act, index) in agentActivity"
              :key="index"
            >
              <p style="font-size:10px;" class="m-0 p-0 my-2">
                #{{ index + 1 }}
              </p>
              <p
                style="font-size:10px;"
                class="m-0 p-0 my-2"
                v-if="
                  act.type == 'Name Changed' ||
                    act.type == 'mobile' ||
                    act.type == 'email' ||
                    act.type == 'address'
                "
              >
                {{ act.description }} by {{ act.name }} on
                <span style="font-size:10px" class="labels">{{
                  act.createdAt | moment("LLL")
                }}</span>
              </p>
              <p style="font-size:10px;" class="m-0 p-0 my-2" v-else>
                Something was created but failed to record.
              </p>
            </div>

            <div v-if="agentActivity.length == 0">
              <p>No Activities</p>
            </div>
            <hr class="mt-0" />
          </div>
          <div class="col-12 text-left m-0 p-0">
            <!-- <p class="m-0 p-0 labels">Contact Information</p> -->
            <div class="col-md-12 m-0 p-0 p-2 my-2">
              <!-- <div class="mb-2">
                <p class="labels m-0 p-0">Email</p>
                <p class="m-0 p-0">{{ customer.email }}</p>
              </div> -->
              <div class="mb-2">
                <p class="labels m-0 p-0">Email</p>
                <div>
                  <b-input-group>
                    <b-form-input type="email" v-model="email"></b-form-input>
                    <b-input-group-append>
                      <b-button
                        :disabled="email == customer.email"
                        @click="updateCustomer('Email')"
                        variant="outline-secondary"
                        >Update</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </div>
                <!-- <p class="m-0 p-0">{{ customer.mobile }}</p> -->
              </div>
              <div class="mb-2">
                <p class="labels m-0 p-0">Phone</p>
                <div>
                  <b-input-group>
                    <b-form-input type="number" v-model="phone"></b-form-input>
                    <b-input-group-append>
                      <b-button
                        :disabled="phone == customer.mobile || phone.length < 10"
                        @click="sendOTP()"
                        variant="outline-secondary"
                        >Update</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </div>
              </div>
              <div class="mb-2">
                <p class="labels m-0 p-0">Alternate Phone</p>
                <div>
                  <b-input-group>
                    <b-form-input type="number" v-model="alternateNo"></b-form-input>
                    <b-input-group-append>
                      <b-button
                        :disabled="alternateNo == customer.alternateNo || alternateNo.length < 10"
                        @click="updateCustomer('Alternate Number')"
                        variant="outline-secondary"
                        >Update</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </div>
              </div>
              <div class="mb-2">
                <p class="labels m-0 p-0">Mobile Verified</p>
                <b-button
                  variant="light border"
                  v-if="customer.mobileVerified == 1"
                  >Verified
                  <button
                    @click="verifyMobile(0)"
                    style="font-size:12px"
                    class="btn btn-danger m-0 ml-1 px-1 p-0"
                  >
                    Disapprove
                  </button>
                </b-button>
                <b-button v-else variant="light border"
                  >Not Verified
                  <button
                    @click="verifyMobile(1)"
                    style="font-size:12px"
                    class="btn btn-success m-0 ml-1 px-1 p-0"
                  >
                    Approve
                  </button>
                </b-button>
              </div>
              <div class="mb-2">
                <!-- <p class="labels m-0 p-0">Address</p>
                <p class="m-0 p-0">{{ customer.address || "-" }}</p> -->

                <div class="mb-2">
                  <p class="labels m-0 p-0">Address</p>
                  <div>
                    <b-input-group>
                      <b-textarea v-model="address"></b-textarea>
                      <b-input-group-append>
                        <b-button
                          :disabled="address == customer.address"
                          @click="updateAddress()"
                          variant="outline-secondary"
                          >Update</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </div>
                </div>
              </div>

              <hr class="m-0 p-0 mb-2" />
              <div class="col-md-12 m-0 p-0">
                <p class="m-0 p-0 labels">Security & Password</p>
                <b-button
                  @click="resetPassword = !resetPassword"
                  variant="light border"
                >
                  <span v-if="!resetPassword">Reset Password</span>
                  <span v-else>Cancel Password Reset</span>
                </b-button>
                <div class="pt-2" v-if="resetPassword">
                  <p class="labels m-0 p-0">Confirm phone to reset password.</p>
                  <div>
                    <b-input-group>
                      <b-form-input
                        type="number"
                        v-model="confirmPhone"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          @click="resetPasswordConfirm"
                          :disabled="resetPasswordEnabled"
                          variant="light border"
                          >Reset</b-button
                        >
                        <b-button
                          @click="resetPassword = !resetPassword"
                          variant="danger"
                          >Cancel</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </div>
                  <div class="labels pt-2">
                    <b-alert variant="danger" show>
                      #Note: After you reset password, the new password will be
                      the customer's phone number i.e {{ customer.mobile }}
                    </b-alert>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 m-0 p-0 mt-2">
          <ul class="list-group" style="cursor:pointer">
            <li class="list-group-item m-0 p-0">
              <!-- <i class="fa fa-file-text" aria-hidden="true"></i> -->
              <router-link
                :to="{
                  path:
                    '/userProfile/' + cx_id + '/' + phone_number + '/documents',
                }"
                class="nav-link py-3"
                exact-active-class="activeLeft"
              >
                <i
                  style="color:#6C757D;font-size:15px"
                  class="fa fa-file-text-o pr-2"
                  aria-hidden="true"
                ></i>
                Documents</router-link
              >
            </li>
            <li class="list-group-item m-0 p-0">
              <router-link
                :to="{
                  path:
                    '/userProfile/' +
                    cx_id +
                    '/' +
                    phone_number +
                    '/activities',
                }"
                class="nav-link py-3"
                exact-active-class="activeLeft"
              >
                <i
                  style="color:#6C757D;font-size:15px"
                  class="fa fa-window-restore pr-2"
                  aria-hidden="true"
                ></i>
                Activities</router-link
              >
            </li>
            <li class="list-group-item m-0 p-0">
              <router-link
                :to="{
                  path:
                    '/userProfile/' + cx_id + '/' + phone_number + '/support',
                }"
                class="nav-link py-3"
                exact-active-class="activeLeft"
              >
                <i
                  style="color:#6C757D;font-size:15px"
                  class="fa fa-headphones pr-2"
                  aria-hidden="true"
                ></i>
                Support History</router-link
              >
            </li>
            <li class="list-group-item m-0 p-0">
              <router-link
                :to="{
                  path:
                    '/userProfile/' +
                    cx_id +
                    '/' +
                    phone_number +
                    '/knowlarity-support',
                }"
                class="nav-link py-3"
                exact-active-class="activeLeft"
              >
                <i
                  style="color:#6C757D;font-size:15px"
                  class="fa fa-headphones pr-2"
                  aria-hidden="true"
                ></i>
                Knowlarity History</router-link
              >
            </li>
            <!-- <li class="list-group-item">Porta ac consectetur ac</li>
              <li class="list-group-item">Vestibulum at eros</li> -->
          </ul>
        </div>
      </div>
      <div class="col-md-8">
        <div class="navs mb-2">
          <ul class="nav nav-tabs">
            <!-- <li class="nav-item">
              <router-link
                :to="{ path: '/userProfile/' + cx_id + '/' + phone_number }"
                class="nav-link"
                exact-active-class="active"
                >Documents</router-link
              >
            </li> -->
            <li class="nav-item">
              <router-link
                :to="{
                  path: '/userProfile/' + cx_id + '/' + phone_number + '/',
                }"
                class="nav-link"
                exact-active-class="active"
                >Booking History</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                :to="{
                  path:
                    '/userProfile/' +
                    cx_id +
                    '/' +
                    phone_number +
                    '/penalty&points',
                }"
                class="nav-link"
                exact-active-class="active"
                >Penalty & Points</router-link
              >
            </li>

            <li class="nav-item">
              <router-link
                :to="{
                  path:
                    '/userProfile/' +
                    cx_id +
                    '/' +
                    phone_number +
                    '/waitlistHistory',
                }"
                class="nav-link"
                exact-active-class="active"
                >Waitlist History</router-link
              >
            </li>
            <!-- <li class="nav-item">
              <router-link
                :to="{
                  path:
                    '/userProfile/' +
                    cx_id +
                    '/' +
                    phone_number +
                    '/activities',
                }"
                class="nav-link"
                exact-active-class="active"
                >Activities</router-link
              >
            </li> -->
            <li class="nav-item">
              <router-link
                :to="{
                  path:
                    '/userProfile/' +
                    cx_id +
                    '/' +
                    phone_number +
                    '/couponHistory',
                }"
                class="nav-link"
                exact-active-class="active"
                >Coupon History</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                :to="{
                  path:
                    '/userProfile/' +
                    cx_id +
                    '/' +
                    phone_number +
                    '/collectionHistory',
                }"
                class="nav-link"
                exact-active-class="active"
                >Collection History</router-link
              >
            </li>
            <!-- <li class="nav-item">
              <router-link
                :to="{
                  path:
                    '/userProfile/' + cx_id + '/' + phone_number + '/support',
                }"
                class="nav-link"
                exact-active-class="active"
                >Support</router-link
              >
            </li> -->
          </ul>
        </div>
        <div class="pb-5 mb-2" style="max-height:700px; overflow:scroll">
          <router-view></router-view>
          <div v-if="makingAJAX">
            <div class="loading jumbotron"></div>
            <div class="loadingText btn-link" style="text-decoration:none">
              <div class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <div class="spinner-grow text-secondary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <div class="spinner-grow text-success" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <div class="spinner-grow text-danger" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="otpModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              OTP sent to {{ phone }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <input
              type="number"
              v-model="otp"
              class="form-control"
              placeholder="Enter OTP sent to customer."
            />
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button type="button" @click="verifyOTP" class="btn btn-primary">
              Verify and Change
            </button>
          </div>
          <div class="text-right col-md-12">
            <p @click="updatePhone(0)" class="btn btn-link">
              Continue without OTP
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// const axios = require('axios');
// import toast from '../toast'
// import * from 'jquery'
const axios = require("axios");
import * as _ from "lodash";
export default {
  data() {
    return {
      alternateNo: null,
      showModal: false,
      cx_id: "",
      phone_number: "",
      currentTab: 0,
      phone: 0,
      resetPassword: false,
      confirmPhone: null,
      resetPasswordEnabled: true,
      fname: "",
      lname: "",
      changeName: false,
      email: null,
      address: null,
      otp: 0,
    };
  },
  // updated() {
  //   this.loadData()
  // },
  watch: {
    customer() {
      this.phone = Number(this.customer.mobile);
      this.email = this.customer.email;
      this.fname = this.customer.fName;
      this.lname = this.customer.lName;
      this.address = this.customer.address;
      this.alternateNo =  this.customer.alternateNo
    },
    confirmPhone() {
      if (this.confirmPhone == this.phone) {
        this.resetPasswordEnabled = false;
      } else {
        this.resetPasswordEnabled = true;
      }
    },
  },

  // updated() {
  //   window.location.reload()
  // },
  created() {
    this.loadData()
  },
  computed: {
    makingAJAX() {
      // return this.$store.state.makingAJAX;
      return false
    },
    agentActivity() {
      return _.orderBy(this.$store.state.agentActivity, "createdAt", "desc");
    },
    customer() {
      return this.$store.state.customer_data;
    },
    loading() {
      return this.$store.state.loading_api;
    },
    models() {
      return this.$store.state.models_list;
    },
    agent_id() {
      return localStorage.getItem("agent_id");
    },
    agent() {
      return localStorage.getItem("username");
    },
    valid() {
      if (this.notification && this.notificationTitle) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    async loadData() {
      this.$store.state.customer_by_number = [];
      this.phone_number = this.$route.params.phone;
      this.cx_id = this.$route.params.cx_id;
      this.currentTab = this.$route.query.tab;
      if (this.phone_number) {
        await this.$store.dispatch("get_customerData", { id: this.cx_id });
        await this.$store.dispatch("getAgentsActivity", { id: this.cx_id });
      } else {
        this.showModal = true;
      }
      const titleEl = document.querySelector('head title');
      titleEl.textContent = 'Profile: ' +this.customer.fName
    },
    sendDM() {
      this.$router.push({
        path: '/sendSms',
        query: {
          mobile: this.phone_number,
          id: this.cx_id,
          name: this.customer.fName
        }
      })
    },
    showOtpModal() {
      window.$("#otpModal").modal("show");
    },
    hideOtpModal() {
      window.$("#otpModal").modal("hide");
    },
    resetPasswordConfirm() {
      axios
        .post(
          "https://api.on-track.in/api/changePasswordBackend",
          {
            id: this.customer.user,
            password: this.customer.mobile,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then(() => {
          (this.resetPassword = false), (this.confirmPhone = "");
          this.$toasted.show("Password Reset Done.", {
            type: "success",
            position: "bottom-center",
            duration: 2000,
            theme: "bubble",
          });
          this.$store.dispatch("get_customerData", { id: this.cx_id });
        })
        .catch(() => {
          this.$toasted.global.my_app_error();
        });
    },
    updateCustomer(key = '') {
      var obj = {}
      var agentActivityKey = ''
      if(key == 'Alternate Number'){
        obj.alternateNo = this.alternateNo
        agentActivityKey = 'alternateNumber'
      }
      if(key == 'Email'){
        obj.email = this.email
        agentActivityKey = 'email'
      }
      axios
        .post(
          "https://api.on-track.in/api/customer/" + this.cx_id,
          obj,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then(() => {
          this.$toasted.show(`${key} updated`, {
            type: "success",
            position: "bottom-center",
            duration: 1000,
            theme: "bubble",
          });
          this.$store.dispatch("get_customerData", { id: this.cx_id });
          this.createActivity(agentActivityKey);
        })
        .catch(() => {
          this.$toasted.global.my_app_error();
        });
    },
    updateName() {
      axios
        .post(
          "https://api.on-track.in/api/customer/" + this.cx_id,
          {
            lName: this.lname,
            fName: this.fname,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then(() => {
          this.changeName = false;
          this.$toasted.show("Name updated", {
            type: "success",
            position: "bottom-center",
            duration: 1000,
            theme: "bubble",
          });
          this.createActivity("Name Changed");
          this.$store.dispatch("get_customerData", { id: this.cx_id });
        })
        .catch(() => {
          this.$toasted.global.my_app_error();
        });
    },
    sendOTP() {
      // this.showOtpModal()
      axios
        .post(
          "https://glacier.on-track.in/api/otp/sendotp",
          {
            phone: this.phone,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then(() => {
          this.$toasted.show("OTP Sent", {
            type: "success",
            position: "bottom-center",
            duration: 1000,
            theme: "bubble",
          });
          // if(x.body.type == 'success'){
          this.showOtpModal();
          // }else{
          //   this.$toasted.show("Cannot sent OTP", {
          //   type: "error",
          //   position: "bottom-center",
          //   duration: 1000,
          //   theme: "bubble",
          // });
          // }
        })
        .catch(() => {
          this.$toasted.global.my_app_error();
        });
    },
    verifyOTP() {
      axios
        .post(
          "https://glacier.on-track.in/api/otp/verifyotp",
          {
            phone: this.phone,
            otp: this.otp,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then(() => {
          this.$toasted.show("OTP verified", {
            type: "success",
            position: "bottom-center",
            duration: 1000,
            theme: "bubble",
          });
          this.updatePhone(1);
          this.hideOtpModal();
        })
        .catch(() => {
          this.$toasted.global.my_app_error();
        });
    },
    updatePhone(verified) {
      this.hideOtpModal();
      if (verified == 1) {
        var dataObj = {
          mobile: this.phone,
          mobileVerified: 1,
        };
      } else {
        dataObj = {
          mobile: this.phone,
          mobileVerified: 0,
        };
      }
      axios
        .post("https://api.on-track.in/api/customer/" + this.cx_id, dataObj, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
          },
        })
        .then(() => {
          this.$toasted.show("Phone updated", {
            type: "success",
            position: "bottom-center",
            duration: 1000,
            theme: "bubble",
          });
          this.$store.dispatch("get_customerData", { id: this.cx_id });
          if (verified == 1) {
            this.createActivity("mobile");
          } else {
            this.createActivity("mobile-notverified");
          }
        })
        .catch(() => {
          this.$toasted.global.my_app_error();
        });
    },
    updateAddress() {
      axios
        .post(
          "https://api.on-track.in/api/customer/" + this.cx_id,
          {
            address: this.address,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then(() => {
          this.$toasted.show("Address updated", {
            type: "success",
            position: "bottom-center",
            duration: 1000,
            theme: "bubble",
          });
          this.$store.dispatch("get_customerData", { id: this.cx_id });
          this.createActivity("address");
        })
        .catch(() => {
          this.$toasted.global.my_app_error();
        });
    },
    createActivity(type) {
      if (type == "Name Changed") {
        var form = {
          agentId: this.agent_id,
          bookingId: this.cx_id,
          description:
            "customer (" +
            this.cx_id +
            ") name has been changed from " +
            this.customer.fName +
            " " +
            this.customer.lName +
            " to " +
            this.fname +
            " " +
            this.lname,
          name: this.agent,
          type: "Name Changed",
        };
      } else if (type == "email") {
        form = {
          agentId: this.agent_id,
          bookingId: this.cx_id,
          description:
            "Old email id is " +
            this.customer.email +
            "&" +
            " new email is " +
            this.email,
          name: this.agent,
          type: "email",
        };
      } else if (type == "mobile") {
        form = {
          agentId: this.agent_id,
          bookingId: this.cx_id,
          description:
            "Old mobile number is " +
            this.customer.mobile +
            " " +
            " new mobile is " +
            this.phone,
          name: this.agent,
          type: "mobile",
        };
      } else if (type == "mobile-notverified") {
        form = {
          agentId: this.agent_id,
          bookingId: this.cx_id,
          description:
            "Old mobile number is " +
            this.customer.mobile +
            " " +
            " new mobile is " +
            this.phone +
            " (not verified)",
          name: this.agent,
          type: "mobile",
        };
      } else if (type == "address") {
        form = {
          agentId: this.agent_id,
          bookingId: this.cx_id,
          description:
            "Old address is " +
            this.customer.address +
            " " +
            " new address is " +
            this.address,
          name: this.agent,
          type: "address",
        };
      } else if (type == "alternateNumber") {
        form = {
          agentId: this.agent_id,
          bookingId: this.cx_id,
          description:
            "Alternate number is " +
            this.customer.alternateNo +
            " " +
            " new alternate number is " +
            this.alternateNo,
          name: this.agent,
          type: "address",
        };
      }
      axios
        .post("https://api.on-track.in/api/createActivity/", form, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
          },
        })
        .then(() => {
          this.$toasted.show("All up-to date", {
            type: "success",
            position: "bottom-center",
            duration: 1000,
            theme: "bubble",
          });
          this.$store.dispatch("get_customerData", { id: this.cx_id });
          this.$store.dispatch("getAgentsActivity", { id: this.cx_id });
        })
        .catch(() => {
          this.$toasted.global.my_app_error();
        });
    },
    changenumber() {
      this.phone_number = "";
      this.showModal = true;
    },
    verifyMobile(state) {
      axios
        .post(
          "https://api.on-track.in/api/customer/" + this.cx_id,
          {
            mobileVerified: state,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then(() => {
          this.$toasted.show("Mobile verified", {
            type: "success",
            position: "bottom-center",
            duration: 1000,
            theme: "bubble",
          });
          this.$store.dispatch("get_customerData", { id: this.cx_id });
        })
        .catch(() => {
          this.$toasted.global.my_app_error();
        });
    },
  },
};
</script>
<style scoped>
.list-group-item:hover {
  background-color: rgb(233, 236, 239);
}
.activeLeft {
  background-color: rgb(233, 236, 239);
}
.loadingText {
  position: absolute;
  top: 50%;
  left: 50%;
}
.loading.jumbotron {
  position: absolute;
  width: 100%;
  top: 0;
  background-color: black;
  opacity: 0.2;
  height: 100%;
  pointer-events: none;
}
.all-notification {
  height: 400px;
  overflow: scroll;
}
.btn:disabled {
  opacity: 0.2;
}
.newservice {
  font-size: 13px;
}

p {
  font-size: 14px;
}
.input-text {
  width: 100%;
  font-size: 14px;
  padding-left: 10px;
}
.result {
  color: rgb(196, 45, 45);
  font-size: 18px;
}
.labels {
  font-size: 14px;
  color: gray;
}
.result span {
  color: rgb(41, 41, 214);
}
.error {
  color: red;
  padding: 0px;
  font-size: 10px;
}
.ontrack-button {
  color: white;
  text-transform: uppercase;
  border: none;
  background-color: #3f35cf;
  padding: 5px;
  width: 50%;
  opacity: 1;
  outline: none;
}
.ontrack-button:hover {
  opacity: 0.87;
}
.button {
  background-color: rgb(240, 240, 240, 0.2);
  border: none;
  color: white;
  padding: 0px 14px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  margin: 8px 0px;
  outline: none;
}
.button5 {
  border-radius: 50%;
}
/* The Modals (background) */
.modals {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

/* Modals Content/Box */
.modals-content {
  background-color: #fefefe;
  margin: 5% auto; /* 15% from the top and centered */
  /* padding: 20px; */
  border: 1px solid #888;
  width: 30%; /* Could be more or less, depending on screen size */
}

/* The Closing Button */
.closing {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.closing:hover,
.closing:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
.loading-dots {
  text-align: left;
  z-index: 5;
  color: rgb(196, 45, 45);
}
.loading-dots .d {
  display: inline;
  margin-left: 0.2em;
  margin-right: 0.2em;
  top: -1em;
  font-size: 1.5em;
}
.edit-btn {
  border-radius: 10px;
  background: rgb(199, 199, 199);
  cursor: pointer;
}
.edit-btn:hover {
  background: gray;
}
.loading-dots .dot {
  display: inline;
  margin-left: 0.2em;
  margin-right: 0.2em;
  top: -1em;
  font-size: 1.5em;
  opacity: 0;
  animation: showHideDot 2.5s ease-in-out infinite;
}
.loading-dots .dot.one {
  animation-delay: 0.2s;
}
.loading-dots .dot.two {
  animation-delay: 0.4s;
}
.loading-dots .dot.three {
  animation-delay: 0.6s;
}

@keyframes showHideDot {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  60% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  display: none;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(0, 0, 255, 0.5);
  border-radius: 0.5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: blue;
}
.icon:hover{
  background: whitesmoke;
  color: #3f35cf;
}
</style>
